import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bbc0c876&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=bbc0c876&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=bbc0c876&prod&lang=scss&scoped=true"
import style2 from "./App.vue?vue&type=style&index=2&id=bbc0c876&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0c876",
  null
  
)

export default component.exports